/**
 * Notification GraphQL Mutations
 *
 * 8 mutations for notification lifecycle and delivery management
 */

import { gql } from '@apollo/client';
import { NOTIFICATION_FIELDS_FRAGMENT } from './fragments';

export const CREATE_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  mutation CreateNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      ...NotificationFields
    }
  }
`;

export const SEND_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  mutation SendNotification($tenantId: String!, $notificationId: String!) {
    sendNotification(tenantId: $tenantId, notificationId: $notificationId) {
      ...NotificationFields
    }
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  mutation MarkNotificationRead($input: MarkNotificationReadInput!) {
    markNotificationRead(input: $input) {
      ...NotificationFields
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationsRead($tenantId: String!, $recipientActorId: String!) {
    markAllNotificationsRead(tenantId: $tenantId, recipientActorId: $recipientActorId)
  }
`;

export const RETRY_NOTIFICATION_DELIVERY = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  mutation RetryNotificationDelivery($input: RetryNotificationInput!) {
    retryNotificationDelivery(input: $input) {
      ...NotificationFields
    }
  }
`;

export const BULK_SEND_NOTIFICATIONS = gql`
  mutation BulkSendNotifications($tenantId: String!, $notificationIds: [String!]!) {
    bulkSendNotifications(tenantId: $tenantId, notificationIds: $notificationIds) {
      successful
      failed
      errors
    }
  }
`;

export const UPDATE_DELIVERY_STATUS = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  mutation UpdateDeliveryStatus($tenantId: String!, $notificationId: String!, $status: NotificationStatus!) {
    updateDeliveryStatus(tenantId: $tenantId, notificationId: $notificationId, status: $status) {
      ...NotificationFields
    }
  }
`;

export const ARCHIVE_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  mutation ArchiveNotification($input: ArchiveNotificationInput!) {
    archiveNotification(input: $input) {
      ...NotificationFields
    }
  }
`;

